import type { Error } from '../types';
import { CONTAIN_SYMBOL_REGEXP } from '../utils/regex';

export const mustContainSymbol =
  (message?: Error['message']) =>
  (value: string): Error => ({
    valid: !!value && CONTAIN_SYMBOL_REGEXP.test(value),
    message
  });
